<template>
  <!-- eslint-disable -->
  <component is="style">
    :root {
      --font-color-primary: #000;
      --primary-darker: #055f30;
      --primary: #1b8158;
      --gray: #999999;
      --gray-light: #dddddd;
      --green: #60bf44;
      --red: #ff3348;
    }

    .strategic-partners .main {
      margin-top: 30px;
    }

    .strategic-partners .about-content {
      margin-top: 50px;
    }

    .strategic-partners .about-content .box-about-desc {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .strategic-partners .about-content .box-about-desc .jump-btn {
      width: 95%;
      margin: 40px auto;
    }

    @media (min-width: 992px) {
      .strategic-partners .about-content .box-about-desc .jump-btn {
        width: 400px;
        margin: 40px 0 0;
      }
    }

    .strategic-partners .about-content .banner {
      width: 100%;
      border-radius: 10px;
    }

    @media (min-width: 992px) {
      .strategic-partners .about-content .banner {
        width: 100%;
        border-radius: 20px;
      }
    }

    .strategic-partners .box-partners {
      margin-top: 80px;
    }

    .strategic-partners .about-title-1 {
      margin-bottom: 55px;
      font-weight: bold;
      font-size: 32px;
      color: var(--primary-darker);
    }

    .strategic-partners .about-desc {
      font-size: 15px;
      line-height: 1.4;
      color: var(--font-color-primary);
    }

    .strategic-partners .jump-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 400px;
      height: 60px;
      margin-top: 18px;
      border-radius: 30px;
      font-weight: 400;
      font-size: 22px;
      text-decoration: none;
      color: #fff;
      background-color: var(--primary);
    }

    .strategic-partners .title-box {
      margin-bottom: 55px;
    }

    .strategic-partners .title-box .about-title-1 {
      margin: 0;
    }

    .strategic-partners .title-box .more-jump {
      text-decoration: none;
      color: var(--gray);
    }

    .strategic-partners .logo-box .img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  </component>
  <div class="strategic-partners">
    <AppBanner
      title="테라사이클 협력사"
      image="https://tc-mini-site-kr-prod-frontend.s3.ap-northeast-2.amazonaws.com/frontend/img/banner-hanjin.08ce2c68.jpg"
    />
    <div class="main container">
      <AppBreadcurmb :routes="[{name: 'Home', to: {name: 'home'}}, {name: 'Strategic Partners', to: {name: 'about_2'}}]" />
      <div class="about-content">
        <h2 class="about-title-1">
          우정사업본부
        </h2>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="box-about-desc">
              <div class="about-desc">
                <p>1884년 우정총국 설립으로 시작된 한국우정의 130년 역사속에서 우정사업본부는 끊임없는 변화와 혁신의 도전과제를 해결하며 성장해 왔습니다. 전국 어디에서나 공평하게 적정한 우편요금으로 서신과 물품 등의 우편물을 접수, 배달하는 보편적 우편서비스는 물론, 공익적 책무를 지고 있는 국가기관으로서 사회적 책임을 다하고 더불어 사는 사회를 만들기 위하여 저소득층 및 소외계층에 대한 사회복지, 정보화 지원, 환경보전, 장학 및 기부 등 다양한 분야에서 사회공헌활동을 펼치고 있습니다.</p>
                <p>특히, 우체국은 범부처와의 협업으로 우편서비스를 활용한 폐의약품 회수, 위기징후 및 독거 가구의 생활 실태 파악, 도서지역의 가스안전 실태 조사 등 다양한 공적 역할을 수행하고 있습니다.</p>
                <p>지난 2023년 1월 폐의약품 회수사업을 시작으로, 분리배출에 대한 시민 인식을 제고 하고, 회수율 향상 등 환경문제 해결에 기여하고 있습니다. 2024년부터는 환경을 위한 ‘에코 우체통’을 설치 및 확장하여 국내 자원순환 문화 확대를 위해 노력하고 있습니다. </p>
                <p>테라사이클과 우정사업본부는 전국에서 발생하는 재활용 어려운 제품 회수 및 재활용을 활성화하고<br>소비 이후 폐기가 아닌 재활용으로 이어질 수 있는 자원 순환 경제 구축을 위해 노력합니다.</p>
                <p>테라사이클 코리아의 모든 재활용 프로그램 수거품은 대한민국의 우정 사업을 담당하는 우정사업본부, 경인지방우정청, 남양주 우체국을 통해 안전하게 운송됩니다.</p>
              </div>
              <a class="jump-btn" target="_blank" href="https://www.koreapost.go.kr/extra/user/kpost/gps/gpsUserView.do">
                나와 가까운 우체국, 우체통 찾기
              </a>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <img src="https://tc-apac-prod.herokuapp.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBd3ZHQWc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--befc89036549c47f54fd4c7742aba0e277c24580/hanjin.JPG" class="banner">
          </div>
        </div>
        <div class="box-partners">
          <div class="title-box d-flex justify-content-between ">
            <h2 class="about-title-1">
              Our Partners
            </h2>
            <!-- <a class="more-jump d-flex align-items-center" href="#">
              <span></span>
            </a> -->
          </div>
          <div class="logo-box">
            <AppCarouselWithController
              :chunk-size="4"
              :mobile-chunk-size="2"
              :show-indicator="false"
              :interval="3000"
              :items="[
                { imgUrl: 'https://tc-mini-site-kr-prod-frontend.s3.ap-northeast-2.amazonaws.com/frontend/img/logo1.7d4fe9b9.jpg', link: '#' },
                { imgUrl: 'https://tc-mini-site-kr-prod-frontend.s3.ap-northeast-2.amazonaws.com/frontend/img/logo2.0e339123.jpg', link: '#' },
                { imgUrl: 'https://tc-mini-site-kr-prod-frontend.s3.ap-northeast-2.amazonaws.com/frontend/img/logo3.e3676ce0.jpg', link: '#' },
                { imgUrl: 'https://tc-mini-site-kr-prod-frontend.s3.ap-northeast-2.amazonaws.com/frontend/img/logo4.01762262.jpg', link: '#' },
                { imgUrl: 'https://tc-apac-prod.herokuapp.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBd0hHQWc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--0823d9ce4aa2d5b44dc4be03269a63b223b617c7/kanu.jpeg', link: '#' },
                { imgUrl: 'https://tc-mini-site-kr-prod-frontend.s3.ap-northeast-2.amazonaws.com/frontend/img/logo10.fb36d53f.jpg', link: '#' },
                { imgUrl: 'https://tc-apac-prod.herokuapp.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBd3pHQWc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--bb2d8f7117582dfdc4ecc64f4c36f376500571e7/partner.gif', link: '#' },
              ]"
            >
              <template #default="item">
                <a :href="item.link">
                  <img :src="item.imgUrl" class="img">
                </a>
              </template>
            </AppCarouselWithController>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

